const $inject = [];
const lbaMultiSelectGroup = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaMultiSelectGroupCtrl',
    controllerAs: 'vm',
    template: require('./lbaMultiSelectGroup.html')
  }
};

lbaMultiSelectGroup.$inject = $inject;

export default lbaMultiSelectGroup;



// WEBPACK FOOTER //
// ./src/components/lbaMultiSelectGroup/lbaMultiSelectGroupDir.js